import { Visibility } from '../visibility/visibility.types';

export type Translation = {
  body: string;
  langCode: string;
};

export type TemplateOpenQuestionOption = {
  id: number;
  translations: Translation[];
  position: number;
};

export type TemplateOpenQuestionsItem = {
  id?: number;
  kind: OpenQuestionKind;
  openQuestionOptions: TemplateOpenQuestionOption[];
  translations: Translation[];
  position?: number;
  required: boolean;
  options?: { length: number };
  visibility?: Visibility;
  visible: boolean;
};

export type OpenQuestionsTemplate = {
  assignedOffersCount: number;
  category: string;
  custom: boolean;
  default: boolean;
  id: number;
  position: number;
  title: string;
  name: string;
  updatedAt: string;
  openQuestions: TemplateOpenQuestionsItem[];
  options?: { length: number };
};

export type OpenQuestionsTemplatePayload = {
  id?: number;
  category: string;
  title: string;
};

export type SaveQuestionPayload = {
  form: any;
  templateId: number;
  questionId?: number;
  offerId?: number;
};

export enum OpenQuestionKind {
  TextSingleLine = 'string',
  TextMultiLine = 'text',
  SingleRadio = 'boolean',
  MultiRadio = 'single_choice',
  Checkbox = 'multi_choice',
  Video = 'video',
  File = 'file',
  InfoBox = 'infobox',
  Legal = 'legal',
}
